import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const RouteTracker = ()=>{
    const location = useLocation();

    useEffect(()=>{
        if (window.gtag){
            window.gtag("event", "page_wiew", {
                page_path: location.pathname,
            });
        }
    },[location]);

    return null;
}

export default RouteTracker;